import { IRichParagraph } from '@seb/web-design-system/core';

export const richParagraphSkeleton: IRichParagraph = {
  heading: {
    data: { title: 'title', description: 'description' }
  }
};

export const richParagraphSkeletonWithLinks: IRichParagraph = {
  heading: {
    data: { title: 'title', description: 'description' }
  },
  links: [
    {
      url: 'http://www.google.fr',
      linkName: ''
    }
  ]
};
